import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import productsReducer from "./slices/productSlice";
import permissionsReducer from "./slices/permissionsSlice";
import userRoleReducer from "./slices/userRoleSlice";
import { supportReducer } from "./slices/supportSlice";
import { helpCenterReducer } from "./slices/helpCenterSlice";
import { termsAndConditionsReducer } from "./slices/termsAndConditionsSlice";
import auditTrailReducer from "./slices/auditTrailSlice";
import { idleTimeReducer } from "./slices/idleTimeSlice";
import mobileAppAlertsReducer from "./slices/mobileAppAlertsSlice";
import notificationsReducer from "./slices/notificationsSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    products: productsReducer,
    support: supportReducer,
    helpCenter: helpCenterReducer,
    termsAndConditions: termsAndConditionsReducer,
    permissions: permissionsReducer,
    userRole: userRoleReducer,
    auditTrail: auditTrailReducer,
    idleTime: idleTimeReducer,
    mobileAppAlerts: mobileAppAlertsReducer,
    notifications: notificationsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
